import React, { useEffect } from "react";
import { TextField, Typography } from "@material-ui/core";
import { useFormik } from "formik";

import { useGetSettingGPT } from "../hooks/useGetSettingGPT";
import { useEditSettingGPT } from "../hooks/useEditSettingGPT";
import { useStyles } from "../hooks/useStyles";
import Preloader from "../../../../components/ui/Loaders/Preloader";
import { useIntl } from "react-intl";
import ButtonWithLoader from "../../../../components/ui/Buttons/ButtonWithLoader";

const MainPromt = () => {
  const classes = useStyles();
  const intl = useIntl();
  const { fetchSetting, loading, setting } = useGetSettingGPT();
  const { fetchSettingEdit, loadingEdit } = useEditSettingGPT();

  const { values, handleChange, handleSubmit } = useFormik({
    initialValues: {
      value: setting?.value || "",
    },
    enableReinitialize: true,
    onSubmit: values => {
      fetchSettingEdit({
        type: "main_promt",
        value: values.value,
      });
    },
  });

  useEffect(() => {
    fetchSetting("main_promt");
  }, []);

  if (loading) {
    return (
      <div className={classes.preloader}>
        <Preloader />
      </div>
    );
  }

  return (
    <div className={classes.formFull}>
      <Typography variant="h6">{intl.formatMessage({ id: "MAIN.PROMT.LABEL" })}</Typography>
      <TextField
        type="text"
        margin="normal"
        name="value"
        onChange={handleChange}
        variant="outlined"
        multiline
        minRows={10}
        value={values.value}
      />
      <ButtonWithLoader loading={loadingEdit} onPress={handleSubmit}>
        {intl.formatMessage({ id: "COMMON.BUTTON.SAVE" })}
      </ButtonWithLoader>
    </div>
  );
};

export default React.memo(MainPromt);
